<template>
  <div class="mc-trackvideo-card--timeout">
    <i class="mc-fa icon-outline_video-off"></i>
    <p>{{ $t('trackVideo.timeout') }}</p>
    <b-button variant="primary" size="sm" @click="$emit('clickContinue')">{{
      $t('trackVideo.continueStreaming')
    }}</b-button>
  </div>
</template>

<script>
export default {
  name: 'StateTimeout',
}
</script>
